<template>
  <div class="h-full">
    <mcs-sheet
      v-if="imagesToRender.length"
      class="overflow-hidden greyLight"
      :style="`height:${fullHeight ? 'calc(100% - 130px)' : 500}`"
      dense
    >
      <v-carousel
        v-if="!singleImageOnly"
        v-model="tab"
        hide-delimiters
        :show-arrows="false"
        :height="fullHeight ? '100%' : 500"
      >
        <v-carousel-item
          v-for="(item, i) in items"
          :key="i"
        >
          <mcs-sheet
            v-if="item.image"
            class="h-full d-flex align-center justify-center greyLight"
            noPadding
          >
            <img
              v-show="imagesLoaded.includes(item.image.url)"
              :src="item.image.url"
              style="max-width: 90%; max-height: 100%"
              @load="imagesLoaded.push(item.image.url)"
            />
            <v-progress-circular
              v-if="!imagesLoaded.includes(item.image.url)"
              :size="100"
              color="black"
              indeterminate
              class="mx-auto"
            ></v-progress-circular>
          </mcs-sheet>
          <Project3dView
            v-if="item.threeD"
            :width="project.width"
            :height="project.height"
            :images="imagesFor3d"
            :modelUrl="core_product.modelUrl"
            :sideNames="core_product.pageAndSideNames"
            :environmentType="core_product.environmentType"
            :foldAnimation="core_product.foldAnimationSpec"
          />
        </v-carousel-item>
      </v-carousel>
      <mcs-sheet
        v-else-if="imagesToRender.length"
        class="h-full d-flex align-center justify-center greyLight"
        noPadding
      >
        <img
          :src="imagesToRender[0].url"
          style="max-width: 90%; max-height: 100%"
        />
      </mcs-sheet>
    </mcs-sheet>
    <v-row
      v-if="!singleImageOnly"
      class="mt-2 mx-4"
    >
      <v-col
        v-for="(item, i) in items"
        :key="i"
        cols="auto"
      >
        <mcs-sheet
          class="greyLight h-full d-flex hover-pointer"
          :class="{ 'border border-primary': tab == i }"
          dense
          @click="tab = i"
        >
          <v-img
            v-if="item.image"
            class="my-auto"
            content-class="my-auto"
            :src="item.image.thumbUrl"
            contain
            max-width="76"
            max-height="65"
          />
          <v-icon
            v-else
            size="40"
            class="px-4"
          >
            mdi-rotate-3d
          </v-icon>
        </mcs-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Project3dView from '@/components/projects/3d/View';
import { mapGetters } from 'vuex';
export default {
  name: 'ProjectPreviewCarousel',
  components: { Project3dView },
  props: {
    project: {
      type: Object,
      default: () => {}
    },
    singleImageOnly: Boolean,
    fullHeight: { type: Boolean, default: false }
  },

  data() {
    return { tab: 0, imagesLoaded: [] };
  },

  computed: {
    imagesFor3d() {
      return this.imagesToRender.filter((x) => !!x.side).map((x) => x.rawUrl || '');
    },
    imagesToRender() {
      if (this.project) return this.project.images || [];
      return [];
    },
    items() {
      let list = [];
      if (
        this.$store.state.config.enable3dPreviews &&
        this.core_product &&
        this.core_product.enable3dView &&
        this.imagesFor3d.length
      ) {
        list.push({ threeD: true });
      }
      list = list.concat(this.imagesToRender.map((x) => ({ image: x })));
      return list;
    },
    core_product() {
      return this.core_product_func(this.project.coreProductId);
    },
    ...mapGetters({ core_product_func: 'templates/core_product' })
  }
};
</script>
